module.exports = __webpack_public_path__ + "static/media/BBDrumdischarge.bd0aa845.png";